<template lang="pug">
.l-map-kumo(
  :style="{height:store.browser.state.windowHeight + 'px'}"
)
  .l-map-kumo__item(
    v-for="item in kumoItems"
    :style="styleObject(item)"
  )
    MapKumoSvg(:item="item")
    
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-kumo
  pos(0,0,6)
  wh(100vw,100vh)
  pointer-events none
  &__item
    position absolute
  
</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent,onMounted,computed,reactive,watch} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import Util from '../../lib/util'
import MapKumoSvg from './MapKumoSvg'

export default defineComponent({
  name:'MapKumo',

  components:{MapKumoSvg},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    
    const staticKumo = reactive({
      items:[
      ]
    })
    const motionKumo = reactive({
      items:[],
      itemsLarge:[]
    })
    const kumoItems = computed(()=>{
      return staticKumo.items.concat(motionKumo.items).concat(motionKumo.itemsLarge)
    })
    const styleObject = computed(()=>{
      return (item)=>{
        return {
          opacity:item.opacity,
          top:item.position == 'top'? '-30px' : 'auto',
          bottom:item.position == 'top'? 'auto' : '-30px',
          left:item.left + 'px',
          transform:'translate('+item.x+'px,'+item.y+'px)'
        }
      }
    })
    const checkPosition = (baseX,baseY,margin,position)=>{
      let a = []
      for(let i=0;i<staticKumo.items.length;i++){
        let v = staticKumo.items[i]
        let a = v.x - baseX
        let b = v.y - baseY
        let distance = Math.sqrt( a*a + b*b )
        if(distance <= margin && v.position == position){
          return true
        }
      }
      return false
    }
    const createKumo = (baseX,baseY,margin,position,motion=false)=>{
      const size = store.ui.state.kumoSize
      const type = Math.floor(Math.random()* 3) + 1
      let scale = 1
      let opacity = 0
      if(motion == 1){
        scale = Math.random() * 0.4 + 0.5
        opacity = 0
      } else if(motion == 2){
        scale = Math.random() * 0.3 + 2.0
        opacity = 0
      } else {
        scale = Math.random() * 0.4 + 0.5
        opacity = Math.random() * 0.1 + 0.9
      }
      const width = size[type].width * scale
      const height = size[type].height * scale
      
      return {
        type:type,
        color:'#FFFFFF',
        opacity:opacity,
        position:position,
        scale:scale,
        width:width,
        height:height,
        x:baseX + Math.random() * margin - margin/2,
        y:baseY + Math.random() * margin/4 - margin/8,
        left:0,
        speed: (Math.random() * 0.4 + 0.3) * (Math.random() > 0.5 ? 1 : -1),
        speedMultiply:1
      }
    }
    const createStaticKumos = (wW,wH)=>{
      //固定用雲
      const margin = 300
      const count = Math.floor(wW / margin)
      staticKumo.items = []
      for(let i=0;i<count;i++){
        let baseX = i * margin
        let baseY = 0
        if(!checkPosition(baseX,baseY,margin,'top')){
          let kumo = createKumo(baseX,baseY,margin,'top')
          staticKumo.items.push(kumo)
        }
        if(!checkPosition(baseX,baseY,margin,'bottom')){
          let kumo = createKumo(baseX,baseY,margin,'bottom')
          staticKumo.items.push(kumo)
        }
      }
    }
    const createMotionKumos = (wW,wH)=>{
      //モーション用雲
      const xMargin = 500
      const yMargin = 200
      const xCount = Math.floor(wW / xMargin) + 2
      const yCount = Math.floor(wH / yMargin) + 2
      motionKumo.items = []
      for(let x=-1;x<xCount;x++){
        for(let y=-1;y<yCount;y++){
          let baseX = x * xMargin
          let baseY = y * yMargin
          let kumo = createKumo(baseX,baseY,xMargin,'top',1)
          motionKumo.items.push(kumo)
        }
      }
      motionKumo.items = Util.shuffle(motionKumo.items)
      
      const xMarginLarge = 400
      const yMarginLarge = 200
      const xCountLarge = Math.floor(wW / xMarginLarge) + 2
      const yCountLarge = Math.floor(wH / yMarginLarge) + 2
      motionKumo.itemsLarge = []
      for(let x=-1;x<xCountLarge;x++){
        for(let y=-1;y<yCountLarge;y++){
          let baseX = x * xMarginLarge
          let baseY = y * yMarginLarge
          let kumo = createKumo(baseX,baseY,xMarginLarge,'top',2)
          motionKumo.itemsLarge.push(kumo)
        }
      }
      motionKumo.itemsLarge = Util.shuffle(motionKumo.itemsLarge)

    }

    let sidResizeHandler = 0
    const resizeHandler = (wW,wH,isFirst=false)=>{
      clearTimeout(sidResizeHandler)

      if(isFirst){
        //固定用雲
        createStaticKumos(wW,wH)
        //モーション用雲
        createMotionKumos(wW,wH)
      } else {
        sidResizeHandler = setTimeout(() => {
          //固定用雲
          createStaticKumos(wW,wH)
          //モーション用雲
          createMotionKumos(wW,wH)
        }, 100);
      }
    }

    const update = (e)=>{
      for(let i=0;i<staticKumo.items.length;i++){
        let v = staticKumo.items[i]
        v.x += v.speed * v.speedMultiply
        if(v.x < -v.width){
          v.x = store.browser.state.windowWidth
        } else if(v.x > store.browser.state.windowWidth){
          v.x = -v.width
        }
      }
      if(store.ui.state.kumoMotion != 0){
        for(let i=0;i<motionKumo.items.length;i++){
          let v = motionKumo.items[i]
          v.x += v.speed * v.speedMultiply
          if(v.x < -v.width){
            v.x = store.browser.state.windowWidth
          } else if(v.x > store.browser.state.windowWidth){
            v.x = -v.width
          }
        }
        for(let i=0;i<motionKumo.itemsLarge.length;i++){
          let v = motionKumo.itemsLarge[i]
          v.x += v.speed * v.speedMultiply
          if(v.x < -v.width){
            v.x = store.browser.state.windowWidth
          } else if(v.x > store.browser.state.windowWidth){
            v.x = -v.width
          }
        }
      }
      window.requestAnimationFrame(update)
    }

    watch(
      ()=> [store.browser.state.windowWidth,store.browser.state.windowHeight],
      (value) => {
        const wW = value[0]
        const wH = value[1]
        resizeHandler(wW,wH);
      }
    )

    watch(
      ()=> [store.ui.state.hotoke],
      (value) => {
        const hotoke = value[0]
        //仏の雲色
        staticKumo.items.forEach((v,i)=>{
          let color = '#FFFFFF'
          if(hotoke && Math.random() > 0.5){
            color = '#ab954f'
          }
          gsap.to(
            v,
            {
              color:color,
              duration:1.0,
              delay:1.0,
              ease:'linaer'
            }
          )
        })
        motionKumo.items.forEach((v,i)=>{
          let color = '#FFFFFF'
          if(hotoke && Math.random() > 0.5){
            color = '#ab954f'
          }
          gsap.to(
            v,
            {
              color:color,
              duration:1.0,
              delay:0.2,
              ease:'linaer',
              overwrite:false
            }
          )
        })
      }
    )

    let kumoMotionTimeline = gsap.timeline()
    const kumoMotionHandler = ()=>{
      const kumoMotion = store.ui.state.kumoMotion
      const kumoMotionDuration = store.ui.state.kumoMotionDuration / 1000
      const kumoMotionDelay = store.ui.state.kumoMotionDelay / 1000
      const delayMargin = kumoMotionDelay / motionKumo.items.length
      const kumoMotionDurationLarge = store.ui.state.kumoMotionDurationLarge / 1000
      const kumoMotionDelayLarge = store.ui.state.kumoMotionDelayLarge / 1000
      const delayMarginLarge = kumoMotionDelayLarge / motionKumo.itemsLarge.length
      const moveX = 200
      const ease = function(t, b, c, d){
        //http://gizma.com/easing/
        t /= d;
        t--;
        return c*(t*t*t + 1) + b;
      }
      if(kumoMotion == 0){
        if(kumoMotionTimeline) kumoMotionTimeline.clear()
        motionKumo.items.forEach((v,i)=>{
          v.opacity = 0
          v.speedMultiply = 15
        })
        motionKumo.itemsLarge.forEach((v,i)=>{
          v.opacity = 0
          v.speedMultiply = 15
        })
      } else if(kumoMotion == 1){
        if(kumoMotionTimeline) kumoMotionTimeline.clear()

        motionKumo.items.forEach((v,i)=>{
          let delay = delayMargin * i
          kumoMotionTimeline.to(
            v,
            {
              opacity:1,
              speedMultiply:2,
              duration:kumoMotionDuration,
              delay:delay,
              ease:'linaer',
              overwrite:false
            }
            ,0
          )
        })
        motionKumo.itemsLarge.forEach((v,i)=>{
          let delay = delayMarginLarge * i + kumoMotionDuration / 2 + kumoMotionDelay / 2
          kumoMotionTimeline.to(
            v,
            {
              opacity:1,
              speedMultiply:1,
              duration:kumoMotionDurationLarge,
              delay:delay,
              ease:'linaer'
            }
            ,0
          )
        })
      } else if(kumoMotion == 2){
        if(kumoMotionTimeline) kumoMotionTimeline.clear()
        let count = 0
        
        motionKumo.items.forEach((v,i)=>{
          let delay = delayMargin/3 * Math.random() * motionKumo.items.length
          // let delay = 0
          kumoMotionTimeline.to(
            v,
            {
              opacity:0,
              speedMultiply:15,
              duration:kumoMotionDuration,
              delay:delay,
              ease:'linaer',
              onComplete:()=>{
                count++
                if(count >= motionKumo.items.length-1){
                  store.ui.state.kumoMotion = 0
                }
              }
            }
            ,0
          )
        })
        motionKumo.itemsLarge.forEach((v,i)=>{
          // let delay = delayMargin/4 * Math.random() * motionKumo.itemsLarge.length
          let delay = 0
          kumoMotionTimeline.to(
            v,
            {
              opacity:0,
              speedMultiply:15,
              duration:kumoMotionDurationLarge,
              delay:0,
              ease:'linaer'
            }
            ,0
          )
        })
      }
    }

    watch(
      ()=> [store.ui.state.kumoMotion],
      (value) => {
        kumoMotionHandler()
      }
    )

    onMounted(()=>{
      resizeHandler(store.browser.state.windowWidth,store.browser.state.windowHeight,true)
      kumoMotionHandler()
      update()
    })
    return{
      store,
      staticKumo,
      motionKumo,
      kumoItems,
      styleObject
    }
  }
})
</script>
